import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Page.Query = {
  selection: {
    if: [
      [
        {
          '=': [
            {
              '@$': 'spaceEntityId',
            },
            'ent:!space:!campus',
          ],
        },
        {
          '@': 'campusLens',
        },
      ],
      [
        {
          '=': [
            {
              '@$': 'spaceEntityId',
            },
            'ent:!space:!bldg',
          ],
        },
        {
          '@': 'buildingLens',
        },
      ],
      [
        {
          '=': [
            {
              '@$': 'spaceEntityId',
            },
            'ent:!space:!floor',
          ],
        },
        {
          '@': 'floorLens',
        },
      ],
      [
        {
          '=': [
            {
              '@$': 'spaceEntityId',
            },
            'ent:!space:!room',
          ],
        },
        {
          '@': 'roomLens',
        },
      ],
      [
        {
          '=': [
            {
              '@$': 'orgEntityId',
            },
            'ent:!org:!dept',
          ],
        },
        {
          '@': 'deptLens',
        },
      ],
      [
        {
          '=': [
            {
              '@$': 'orgEntityId',
            },
            'ent:!org:!subdept',
          ],
        },
        {
          '@': 'subdeptLens',
        },
      ],
      [
        {
          not: {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
        },
        {
          '@': 'piLens',
        },
      ],
      {
        '@': 'InstitutionLens',
      },
    ],
  },
  subqueries: {
    piLens: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      target: 'ent:!personnel:!employee',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            '@.': '!name',
          },
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'piRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'piRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
            ],
          },
          breadcrumbs: {
            '[]': [
              {
                '{}': {
                  goto: {
                    '{}': {
                      variables: {
                        '{}': {},
                      },
                      navigationId: 'explore',
                    },
                  },
                  name: 'Institution',
                },
              },
            ],
          },
        },
      },
    },
    deptLens: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'orgRecordId',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@$': 'orgRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      target: 'ent:!org:!dept',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            if: [
              [
                {
                  '=': [
                    {
                      '@$': 'orgEntityId',
                    },
                    'ent:!org:!dept',
                  ],
                },
                {
                  '@.': '!name',
                },
              ],
              'Institution',
            ],
          },
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
            ],
          },
          breadcrumbs: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {},
                          },
                          navigationId: 'explore',
                        },
                      },
                      name: 'Institution',
                    },
                  },
                ],
              },
              {
                '@': 'ancestorsBreadcrumbs',
              },
            ],
          },
        },
      },
      subqueries: {
        ancestorsBreadcrumbs: {
          target: 'ancestors',
          selection: {
            '{}': {
              goto: {
                '{}': {
                  variables: {
                    '{}': {
                      orgLevel: {
                        '@_': ['child', 'name'],
                      },
                      orgEntityId: {
                        '@_': 'id',
                      },
                      orgRecordId: {
                        '@.': '!id',
                      },
                    },
                  },
                  navigationId: 'explore',
                },
              },
              name: {
                '@.': '!name',
              },
            },
          },
        },
      },
    },
    roomLens: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'spaceRecordId',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@$': 'spaceRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      target: 'ent:!space:!room',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            '@.': '!name',
          },
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
            ],
          },
          breadcrumbs: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {},
                          },
                          navigationId: 'explore',
                        },
                      },
                      name: 'Institution',
                    },
                  },
                ],
              },
              {
                '@': 'ancestorsBreadcrumbs',
              },
            ],
          },
        },
      },
      subqueries: {
        ancestorsBreadcrumbs: {
          target: 'ancestors',
          selection: {
            '{}': {
              goto: {
                '{}': {
                  variables: {
                    '{}': {
                      spaceEntityId: {
                        '@_': 'id',
                      },
                      spaceRecordId: {
                        '@.': '!id',
                      },
                    },
                  },
                  navigationId: 'explore',
                },
              },
              name: {
                '@.': '!name',
              },
            },
          },
        },
      },
    },
    floorLens: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'spaceRecordId',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@$': 'spaceRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      target: 'ent:!space:!floor',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            '@.': '!name',
          },
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
            ],
          },
          breadcrumbs: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {},
                          },
                          navigationId: 'explore',
                        },
                      },
                      name: 'Institution',
                    },
                  },
                ],
              },
              {
                '@': 'ancestorsBreadcrumbs',
              },
            ],
          },
        },
      },
      subqueries: {
        ancestorsBreadcrumbs: {
          target: 'ancestors',
          selection: {
            '{}': {
              goto: {
                '{}': {
                  variables: {
                    '{}': {
                      spaceEntityId: {
                        '@_': 'id',
                      },
                      spaceRecordId: {
                        '@.': '!id',
                      },
                    },
                  },
                  navigationId: 'explore',
                },
              },
              name: {
                '@.': '!name',
              },
            },
          },
        },
      },
    },
    campusLens: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'spaceRecordId',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@$': 'spaceRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      target: 'ent:!space:!campus',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            '@.': '!name',
          },
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
            ],
          },
          breadcrumbs: {
            '[]': [
              {
                '{}': {
                  goto: {
                    '{}': {
                      variables: {
                        '{}': {},
                      },
                      navigationId: 'explore',
                    },
                  },
                  name: 'Institution',
                },
              },
            ],
          },
        },
      },
    },
    subdeptLens: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'orgRecordId',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@$': 'orgRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      target: 'ent:!org:!subdept',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            '@.': '!name',
          },
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
            ],
          },
          breadcrumbs: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {},
                          },
                          navigationId: 'explore',
                        },
                      },
                      name: 'Institution',
                    },
                  },
                ],
              },
              {
                '@': 'ancestorsBreadcrumbs',
              },
            ],
          },
        },
      },
      subqueries: {
        ancestorsBreadcrumbs: {
          target: 'ancestors',
          selection: {
            '{}': {
              goto: {
                '{}': {
                  variables: {
                    '{}': {
                      orgEntityId: {
                        '@_': 'id',
                      },
                      orgRecordId: {
                        '@.': '!id',
                      },
                    },
                  },
                  navigationId: 'explore',
                },
              },
              name: {
                '@.': '!name',
              },
            },
          },
        },
      },
    },
    buildingLens: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'spaceRecordId',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@$': 'spaceRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      target: 'ent:!space:!bldg',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            '@.': '!name',
          },
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  {
                    '@.': '!id',
                  },
                ],
              },
            ],
          },
          breadcrumbs: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {},
                          },
                          navigationId: 'explore',
                        },
                      },
                      name: 'Institution',
                    },
                  },
                ],
              },
              {
                '@': 'ancestorsBreadcrumbs',
              },
            ],
          },
        },
      },
      subqueries: {
        ancestorsBreadcrumbs: {
          target: 'ancestors',
          selection: {
            '{}': {
              goto: {
                '{}': {
                  variables: {
                    '{}': {
                      spaceEntityId: {
                        '@_': 'id',
                      },
                      spaceRecordId: {
                        '@.': '!id',
                      },
                    },
                  },
                  navigationId: 'explore',
                },
              },
              name: {
                '@.': '!name',
              },
            },
          },
        },
      },
    },
    InstitutionLens: {
      target: 'ent:!space:!campus',
      quantity: 1,
      selection: {
        '{}': {
          title: 'Institution',
        },
      },
    },
  },
}
